import React from 'react';
import { Game } from '../game';

export function Home() {
  return (
    <main className="main">
      <div className="main__wrapper">
        <div className="main__title">
          Nicolas Olenev
          <span className="main__subtitle"> &gt; Front-end developer</span>
        </div>
        <div className="main__skills">
          <ul>
            <li>High: JavaScript, HTML, CSS, Git,</li>
            <li>Medium: React, Redux, REST API, Webpack,</li>
            <li>Basic: PHP, MySQL, TypeScript, mobX, Ant Design, React Saga</li>
          </ul>
        </div>
      </div>
      <Game />
    </main>
  );
}
